import axios from 'shared/tools/axiosMultisite';

const URL_ADD_SAMPLE_TO_BASKET_API = '/api/basketService/addproductsamples';

export const addSampleToBasket = async function addSampleToBasket(data, language) {
	try {
		return await axios.post(`${URL_ADD_SAMPLE_TO_BASKET_API}?language=${language}`, data)
	} catch (err) {
		console.error(err);
	}
}

const AddSampleToBasketService = {
	addSampleToBasket,
};

export default AddSampleToBasketService;
